(() => {
  const toc = document.getElementById("ArticleTOC");
  const list = document.getElementById("ArticleTOCList");
  if (!toc || !list) return;

  const content =
    document.querySelector(".article-template__content.rte") ||
    document.querySelector(".article-template__content") ||
    document.querySelector(".rte");

  if (!content) return;


  const headings = Array.from(content.querySelectorAll("h2, h3"))
    .filter(h => h.textContent && h.textContent.trim().length > 0);

  if (headings.length < 2) return;

  const slugify = (text) =>
    text
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^\w\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");

  const usedIds = new Set();
  const ensureUniqueId = (base) => {
    let id = base || "sekcja";
    let i = 2;
    while (document.getElementById(id) || usedIds.has(id)) id = `${base}-${i++}`;
    usedIds.add(id);
    return id;
  };

  let currentH2Li = null;

  headings.forEach((h) => {
    if (!h.id) h.id = ensureUniqueId(slugify(h.textContent));
    else if (usedIds.has(h.id)) h.id = ensureUniqueId(h.id);
    usedIds.add(h.id);

    const a = document.createElement("a");
    a.href = `#${h.id}`;
    a.textContent = h.textContent.trim();
    a.className = `toc__link toc__link--${h.tagName.toLowerCase()}`;

    const li = document.createElement("li");
    li.className = `toc__item toc__item--${h.tagName.toLowerCase()}`;
    li.appendChild(a);

    if (h.tagName.toLowerCase() === "h2") {
      list.appendChild(li);
      currentH2Li = li;
    } else {
      if (!currentH2Li) {
        list.appendChild(li);
        return;
      }
      let sub = currentH2Li.querySelector("ol");
      if (!sub) {
        sub = document.createElement("ol");
        sub.className = "toc__sublist";
        currentH2Li.appendChild(sub);
      }
      sub.appendChild(li);
    }
  });

  toc.hidden = false;

  // Na desktop od razu otwarty
  if (window.matchMedia("(min-width: 990px)").matches) toc.open = true;

  list.addEventListener("click", (e) => {
    const link = e.target.closest("a[href^='#']");
    if (!link) return;
    const target = document.querySelector(link.getAttribute("href"));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
    history.replaceState(null, "", link.getAttribute("href"));
  });
})();
